

































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import echarts from "echarts";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    let d: any = JSON.parse(JSON.stringify(this.detail));
    d.score = [];
    this.score.forEach((ele: any) => {
      ele.value = this.detail.report["得分"][ele.type];
    });
    d.score = this.score;
    this.data = d;
    this.drawEcharts();
  }
  private data: any = {};
  private score: any = [
    {
      type: "平和质",
      unit: "分",
      value: "",
    },
    {
      type: "阳虚质",
      unit: "分",
      value: "",
    },
    {
      type: "气虚质",
      unit: "分",
      value: "",
    },
    {
      type: "阴虚质",
      unit: "分",
      value: "",
    },
    {
      type: "痰湿质",
      unit: "分",
      value: "",
    },
    {
      type: "血瘀质",
      unit: "分",
      value: "",
    },
    {
      type: "特禀质",
      unit: "分",
      value: "",
    },
    {
      type: "湿热质",
      unit: "分",
      value: "",
    },
    {
      type: "气郁质",
      unit: "分",
      value: "",
    },
  ];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private header: any = ["类型", "您的得分"];
  private colors: any = ["#08C664", "#F2A732", "#AE6B07", "#F60D0D"];
  private optionData: any = {};
  private optionData2: any = {};
  private drawEcharts() {
    if (!this.data.report || !this.data.report.echarts) {
      return;
    }
    let xData: any = [];
    let yData: any = [];
    let indicator: any = [];
    this.data.report.echarts.data.forEach((ele: any) => {
      xData.push(ele.name);
      yData.push(ele.value);
      indicator.push({
        name: ele.name,
        max: 120,
        textStyle: {
          color: "blue", // 设置指示器名称的颜色为蓝色
        },
      });
    });
    this.optionData = {
      color: ["#1B5AB2"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: xData,
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: [
        {
          name: "分数",
          type: "bar",
          data: yData,
          barWidth: "40",
          itemStyle: {
            barBorderRadius: 20,
          },
        },
      ],
    };
    this.optionData2 = {
      radar: {
        // shape: 'circle',
        name: {
          textStyle: {
            color: "#333",
          },
        },
        indicator: indicator,
      },
      series: [
        {
          name: "",
          type: "radar",
          data: [
            {
              value: yData,
            },
          ],
          label: {
            show: true,
            color: "#333",
          },
        },
      ],
    };
  }
  private editorChange(e: any) {
    const d = JSON.parse(JSON.stringify(this.detail));
    d.report["建议"].suggest = e;
    this.$emit("changeData", d);
  }
  private open(url: any) {
    window.open(url);
  }
  private drawEcharts2() {
    if (!this.detail.report || !this.detail.report["五脏分析"]) {
      return;
    }
    const d = {
      type: this.detail.report["五脏分析"]["部位"],
      data: [
        { value: 1, name: "心" },
        { value: 1, name: "肝" },
        { value: 1, name: "脾" },
        { value: 1, name: "肺" },
        { value: 1, name: "肾" },
      ],
    };
    const Chart: any = echarts.init(this.$refs.echarts as HTMLCanvasElement);
    const option = {
      series: [
        {
          type: "pie",
          radius: ["20%", "80%"],
          center: ["50%", "50%"],
          roseType: "area",
          // 添加间距设置
          itemStyle: {
            borderWidth: 2,
            borderColor: "#fff",
          },
          label: {
            show: true,
            position: "inside",
            formatter: "{b}",
            color: "#fff",
            fontSize: 18,
            lineHeight: 16,
            align: "center",
            verticalAlign: "middle",
          },
          labelLine: {
            show: false,
          },
          data: d.data.map((item) => ({
            ...item,
            itemStyle: {
              color: d.type.includes(item.name) ? "#fac858" : "#1B5AB2",
            },
          })),
        },
      ],
    };
    Chart.setOption(option, true);
    Chart.off("click");
    Chart.on("click", (p: any) => { });
  }
  private mounted() {
    this.drawEcharts2();
  }
}
